import React from 'react';
import PropTypes from 'prop-types';

export const SiteSelectorList = ({ selected, handleChange, websiteList, styles }) => {
    return (
        <select
            value={selected}
            onChange={handleChange}
            style={{ ...styles, opacity: 0, position: 'absolute' }}
        >
            {websiteList.map((website) => {
                return (
                    <option key={website.id} value={website.id} dangerouslySetInnerHTML={{ __html: `${website.label} (${website.currency})&lrm;` }} />
                );
            })}
        </select>
    );
};

SiteSelectorList.propTypes = {
    selected: PropTypes.string.isRequired,
    websiteList: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    styles: PropTypes.object,
};
SiteSelectorList.defaultProps = {
    styles: {},
};
